// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2vD_G","colCheckbox":"styles_colCheckbox__2thUp"};